import * as step3Const from './constants';

export default {
    [step3Const.AllVpcInfo](state, allVpcSet) {
        state.allVpcSet = allVpcSet;
    },
    [step3Const.AllocatedAdrList](state, NotAvailableIpAddress) {
        state.NotAvailableIpAddress = NotAvailableIpAddress.AvailableIpAddress;
    },
    [step3Const.DescribePrivateIpAddressAttributes](state, NotAvailableIpAddress) {
        state.PrivateIpAddressAttributeSet = NotAvailableIpAddress.PrivateIpAddressAttributeSet;
    },
    [step3Const.AdrList](state, adrListSet) {
        state.adrListSet = adrListSet;
    },
    [step3Const.DescribeSubnets](state, SubnetSet) { 
        state.SubnetSet = SubnetSet.SubnetSet;
    },
    //--以下为未登录mutations--
    [step3Const.noLoginAllVpcInfo](state, allVpcSet) {
        state.allVpcSet = allVpcSet;
    },
    [step3Const.noLoginAdrList](state, adrListSet) {
        state.adrListSet = adrListSet;
    },
    //--以上为未登录mutations--
}